/**
 * Descarga un Blob como archivo en el navegador.
 * Uso: downloadFile(blob, 'clientes-2025-01-01.csv')
 */
export function downloadFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a   = document.createElement('a');
  a.href     = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Genera nombre de archivo con fecha de hoy. Ej: 'clientes-2025-01-01.csv' */
export function csvFilename(module: string): string {
  return `${module}-${new Date().toISOString().slice(0, 10)}.csv`;
}
